export default "__VITE_ASSET__BwJ5E7Zy__";